
import { defineComponent, PropType } from 'vue'
import { CtCatalogue } from '@/models/interfaces/content-type'
import PenIcon from '@/components/Icons/PenIcon.vue'
import MinusCircleIcon from '@/components/Icons/MinusCircleIcon.vue'

export default defineComponent({
  name: 'ChannelCard',
  components: { MinusCircleIcon, PenIcon },
  props: {
    channel: {
      type: Object as PropType<CtCatalogue>,
      required: true,
    },
    draft: {
      type: Boolean,
      default: false,
    },
    pendingUnlink: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['channel-click', 'unlink'],
  setup () {
    return {

    }
  }
})
